module.exports = __webpack_public_path__ + "static/media/prezident.92e77a19.jpg";